import React from 'react'
import HeroImg from '../components/HeroImg'

export default function Home() {
    return (
        <>
        <HeroImg />
        </>
    )
}
